var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 28,
    viewBox: "0 0 154 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7447 24.8528C32.7447 26.591 31.3388 28 29.6047 28H24.3949C22.6607 28 21.2549 26.591 21.2549 24.8528V19.5517C21.2549 17.8135 22.6607 16.4045 24.3949 16.4045H29.6047C31.3388 16.4045 32.7447 17.8136 32.7447 19.5517V24.8528Z",
    fill: "#141320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14 11.5955C6.40578 11.5955 4.99992 10.1864 5 8.4483V3.14719C5 1.409 6.40578 0 8.14 0H13.3497C15.084 0 16.4897 1.409 16.4897 3.14719V8.4483C16.4897 10.1864 15.084 11.5955 13.3497 11.5955H8.14Z",
    fill: "#141320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6047 0C31.3388 0 32.7447 1.40907 32.7447 3.14718V8.4483C32.7447 10.1865 31.3388 11.5955 29.6047 11.5955H24.3949C22.6607 11.5955 21.2549 10.1865 21.2549 8.4483V3.14718C21.2549 1.40907 22.6607 0 24.3949 0H29.6047Z",
    fill: "#141320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8577 22.975V8.04947H56.948V22.975H52.8577ZM47.7448 8.54125V5.02502H62.0858V8.54125H47.7448Z",
    fill: "#141320"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9191 22.975L63.4297 5.02502H67.6447L71.1614 20.2702L70.2885 19.7047H72.5581L71.5854 20.2702L74.304 5.68893H77.696L74.1294 22.975H67.9191ZM78.7684 22.975L74.9275 5.68893H78.4941L81.6366 20.2702L80.6889 19.7047H82.8587L82.0357 20.2702L85.1034 5.02502H89.094L85.1034 22.975H78.7684Z",
    fill: "#141320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6702 22.975V5.02502H95.6607V22.975H91.6702ZM95.1619 22.975V19.6309H103.118V22.975H95.1619ZM95.1619 15.5245V12.1804H102.544V15.5245H95.1619ZM95.1619 8.36913V5.02502H102.943V8.36913H95.1619Z",
    fill: "#141320"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.479 22.975V5.02502H110.57V22.975H106.479ZM110.071 22.975V19.4342H117.703V22.975H110.071Z",
    fill: "#141320"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.551 22.975L117.014 5.02502H121.229L125.618 20.1719L124.671 19.7047H127.215L126.217 20.1719L130.282 5.02502H134.373L129.21 22.975H122.551Z",
    fill: "#141320"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.998 22.975V5.02502H140.988V22.975H136.998ZM140.489 22.975V19.6309H148.446V22.975H140.489ZM140.489 15.5245V12.1804H147.872V15.5245H140.489ZM140.489 8.36913V5.02502H148.271V8.36913H140.489Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a135bbbae67b9f97a3acee240702cfc8.svg";
export { ForwardRef as ReactComponent };